export const ORDER_V2_GROUPS = ["Amministrazione", "Milkrun", "Tecnici"];
export const ORDER_V2_EDIT_GROUPS = ["Milkrun", "Tecnici"];

export function canAccessOrderV2(user = {}) {
    const groups = Array.isArray(user.groups) ? user.groups : [];
    return user.admin === true || ORDER_V2_GROUPS.some((group) => groups.includes(group));
}

export function canEditOrderV2(user = {}) {
    const groups = Array.isArray(user.groups) ? user.groups : [];
    return user.admin === true || ORDER_V2_EDIT_GROUPS.some((group) => groups.includes(group));
}
